import { render } from "./HemodialysisPage.vue?vue&type=template&id=1249a939&scoped=true"
import script from "./HemodialysisPage.vue?vue&type=script&lang=js"
export * from "./HemodialysisPage.vue?vue&type=script&lang=js"

import "./HemodialysisPage.vue?vue&type=style&index=0&id=1249a939&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1249a939"]])

export default __exports__